"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useChildrenChange = useChildrenChange;
exports.useIsPopOverOpen = useIsPopOverOpen;
exports.useAdjustWidth = useAdjustWidth;
exports.useOptionSelected = useOptionSelected;
exports.useHasFooter = useHasFooter;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _useListBox11 = _interopRequireDefault(require("../useListBox"));

var _PropsProvider = require("../store/PropsProvider");

var _optionState = require("../components/Option/helpers/optionState");

// we should export a hook from the popover so we get notify when the popover state for isOpen change meanwhile:
function waitForPopoverAnimation(func) {
  setTimeout(func, 300);
}

function useChildrenChange(children) {
  var _useListBox = (0, _useListBox11["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 2),
      state = _useListBox2[0],
      dispatch = _useListBox2[1];

  _react["default"].useEffect(function () {
    var _getDataOptions = (0, _optionState.getDataOptions)(children),
        options = _getDataOptions.options,
        optionsIndex = _getDataOptions.optionsIndex;

    if ((0, _keys["default"])(state.options).length === (0, _keys["default"])(options).length) {
      var difference = (0, _values["default"])(state.options).find(function (prevOption, key) {
        return !(0, _lodash["default"])(prevOption.value, options[key].value) || prevOption.isDisabled !== options[key].isDisabled || prevOption.isSelected !== options[key].isSelected;
      });
      if (!difference) return;
    }

    dispatch({
      type: _useListBox11["default"].types.updateOptions,
      payload: {
        options: options,
        optionsIndex: optionsIndex
      }
    });
  }, [children, dispatch, state.hasFooter, state.options]);
}

function useIsPopOverOpen(shouldKeepTriggerFocus) {
  var _useListBox3 = (0, _useListBox11["default"])(),
      _useListBox4 = (0, _slicedToArray2["default"])(_useListBox3, 2),
      state = _useListBox4[0],
      dispatch = _useListBox4[1];

  var hasFilter = state.hasFilter,
      hasPopupOpened = state.hasPopupOpened,
      isOpen = state.isOpen,
      refFilterInput = state.refFilterInput,
      refListBoxContainer = state.refListBoxContainer,
      refTrigger = state.refTrigger,
      refTriggerContainer = state.refTriggerContainer;

  var _React$useContext = _react["default"].useContext(_PropsProvider.PropsContext),
      isInline = _React$useContext.isInline;

  _react["default"].useLayoutEffect(function () {
    if (isInline) return;
    if (!refListBoxContainer.current) return;
    var filterInput = refFilterInput.current;
    var listBoxContainer = refListBoxContainer.current;
    var trigger = refTrigger.current;

    if (isOpen) {
      dispatch({
        type: _useListBox11["default"].types.setTriggerWidth,
        payload: refTriggerContainer.current.offsetWidth
      });

      if (!shouldKeepTriggerFocus) {
        waitForPopoverAnimation(function () {
          return hasFilter ? filterInput.focus() : listBoxContainer.focus();
        });
      }

      return;
    }

    if (hasPopupOpened) {
      listBoxContainer.focus();

      if (isInline === false && isOpen === false && trigger) {
        trigger.focus();
      }
    }
  }, [dispatch, hasFilter, hasPopupOpened, isInline, isOpen, refFilterInput, refListBoxContainer, refTrigger, refTriggerContainer, shouldKeepTriggerFocus]);
}

function useAdjustWidth() {
  var _useListBox5 = (0, _useListBox11["default"])(),
      _useListBox6 = (0, _slicedToArray2["default"])(_useListBox5, 2),
      state = _useListBox6[0],
      dispatch = _useListBox6[1];

  _react["default"].useLayoutEffect(function () {
    var $triggerContainer = state.refTriggerContainer.current;

    if ($triggerContainer) {
      dispatch({
        type: _useListBox11["default"].types.setTriggerWidth,
        payload: $triggerContainer.offsetWidth
      });
    }

    var handleResize = function handleResize() {
      if ($triggerContainer) {
        dispatch({
          type: _useListBox11["default"].types.setTriggerWidth,
          payload: $triggerContainer.offsetWidth
        });
      }
    };

    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch, state.refTriggerContainer]);
}

function useOptionSelected() {
  var _useListBox7 = (0, _useListBox11["default"])(),
      _useListBox8 = (0, _slicedToArray2["default"])(_useListBox7, 2),
      state = _useListBox8[0],
      dispatch = _useListBox8[1];

  _react["default"].useEffect(function () {
    if (state.onChangeFn) {
      state.onChangeFn(state, dispatch);
    }
  }, [dispatch, state, state.selectedOptions]);
}

function useHasFooter(footer) {
  var _useListBox9 = (0, _useListBox11["default"])(),
      _useListBox10 = (0, _slicedToArray2["default"])(_useListBox9, 2),
      dispatch = _useListBox10[1];

  _react["default"].useEffect(function () {
    if (footer) {
      dispatch({
        type: _useListBox11["default"].types.setHasFooter,
        payload: true
      });
    }
  }, [dispatch, footer]);
}
//# sourceMappingURL=hooks.js.map